import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    justify-content: center;
    position: relative;

    button {
        border: none;
        background: var(--mainTheme);
        color: #FFF;
        padding: 1rem;
        border-radius: 5px;
        min-width: 10rem;
    }
`
